import React from 'react';
import { numberToCurrency } from './currency.helpers';

interface DisplayFieldProps {
  label: string;
  value: number;
  className?: string;
}

const DisplayField: React.FC<DisplayFieldProps> = ({ label, value, className = '' }) => {
  return (
    <div className={`pb-2 ${className}`}>
      <label className="font-semibold text-sm">{label}</label>
      <p className="border border-gray h-[43px] text-gray2 p-2 overflow-hidden rounded w-full bg-[#ffffff]">
        {numberToCurrency(value)}
      </p>
    </div>
  );
};

export default DisplayField;